import classnames from 'classnames/bind'
import React from 'react'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface SeparatorProps {
  className?: string
}

function Separator({ className }: SeparatorProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })

  return (
    <div className={cx(css.Separator, className, gridStyle)}>
      <div className={css.line} />
    </div>
  )
}

Separator.defaultProps = {}

export default Separator
